// src/lawyerSelection/components/AvailabilityCalendar.js
import React from "react";
import "./availabilityCalendar.css"; // Ensure this CSS file exists

/**
 * @param {Object[]} availability
 * @param {function} onDayClick - A callback invoked when a user clicks on a day that has availability
 */
const AvailabilityCalendar = ({ availability, onDayClick }) => {
  const today = new Date();
  const todayDate = new Date().setHours(0, 0, 0, 0); // Start of today

  if (!Array.isArray(availability)) {
    return <div className="error-message">No availability data available.</div>;
  }

  const splitSlotIntoHours = (slots) => {
    let totalHours = 0;

    slots.forEach(({ start_time, end_time }) => {
      // Parse as UTC and then diff
      const start = new Date(`1970-01-01T${start_time}Z`);
      const end = new Date(`1970-01-01T${end_time}Z`);

      const hoursAvailable = Math.floor((end - start) / (1000 * 60 * 60));
      totalHours += hoursAvailable;
    });

    return totalHours;
  };

  return (
    <div className="availability-calendar">
      {availability.map((day) => {
        const dateObj = new Date(day.date);
        const isPast = dateObj < todayDate;
        const isGray = day.slots.length === 0;

        return (
          <div
            key={day.date}
            className={`availability-day ${
              isPast ? "past" : isGray ? "gray" : ""
            }`}
            title={
              isGray
                ? "No available slots"
                : isPast
                  ? "Past Date"
                  : "Available for consultation"
            }
            onClick={() => {
              // Only allow clicks on days that are not in the past and that have availability
              if (!isPast && !isGray && onDayClick) {
                onDayClick(day);
              }
            }}
          >
            <span className="day-name">{day.day}</span>
            <span className="date">{dateObj.toLocaleDateString()}</span>
            {day.slots.length > 0 ? (
              <span className="slots">
                {splitSlotIntoHours(day.slots)} Available Slot
                {splitSlotIntoHours(day.slots) > 1 ? "s" : ""}
              </span>
            ) : (
              <span className="no-slots">Not Available</span>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default AvailabilityCalendar;
